import React from 'react';
import { Link } from 'react-router-dom';

import { FollowPlaylistButton } from 'components/playlists/FollowPlaylistButton';
import { Icon } from 'components/icons/Icon';

import * as Types from 'types';

type Props = {
  compatibilities: 'editable' | 'orderable' | 'followable';
  playlistId: number | undefined;
  playlist: Types.Playlist;
  onPlay: () => void;
};

export const ButtonsDefault: React.FC<Props> = ({
  compatibilities,
  playlist,
  playlistId,
  onPlay,
}) => {
  return (
    <>
      <div className='col-6 col-sm-auto'>
        {compatibilities === 'followable' && playlistId ? (
          <FollowPlaylistButton
            playlistId={playlistId}
            className='btn btn--medium btn--border-light w-100 w-sm-auto mr-1'
          />
        ) : null}
        {compatibilities === 'editable' || compatibilities === 'orderable' ? (
          <Link
            to={Routes.edit_vault_playlist_path(playlist.id)}
            className='btn btn--border-light btn--border-vault w-100 w-sm-auto mr-1'
          >
            {compatibilities === 'orderable' ? 'Reorder' : 'Edit'}
          </Link>
        ) : null}
      </div>
      {playlist.items.length > 0 ? (
        <div className='col-6 col-sm-auto'>
          <a
            onClick={(event) => {
              event.preventDefault();
              onPlay();
            }}
            className='btn btn--medium btn--border-cta w-100 w-sm-auto p-0'
          >
            <Icon
              icon='play'
              style={{
                width: '33px',
                height: '33px',
                display: 'block',
                margin: '0 auto',
              }}
            />
          </a>
        </div>
      ) : null}
    </>
  );
};
